import React from 'react';

const TableLoader = () => (
  <div className="NewBaseTable__loader">
    <div className="NewBaseTable__loader-spinner" />
  </div>
);

export default TableLoader;
